/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Architect_Output9Inputs */

const en_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension blueprint`)
};

const ar_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المخطط التفصيلي للإضافة`)
};

const bn_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সটেনশন ব্লুপ্রিন্ট`)
};

const de_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterungsentwurf`)
};

const es_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de extensión`)
};

const fr_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan d'extension`)
};

const pt_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de extensão`)
};

const zh_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩展蓝图`)
};

const tr_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzantı planı`)
};

const ru_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схема расширения`)
};

const pl_svc_browser_extensions_architect_output9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan rozszerzenia`)
};

/**
* | output |
* | --- |
* | "Extension blueprint" |
*
* @param {Svc_Browser_Extensions_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_architect_output9 = /** @type {((inputs?: Svc_Browser_Extensions_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_architect_output9(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_architect_output9(inputs)
	if (locale === "de") return de_svc_browser_extensions_architect_output9(inputs)
	if (locale === "es") return es_svc_browser_extensions_architect_output9(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_architect_output9(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_architect_output9(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_architect_output9(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_architect_output9(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_architect_output9(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_architect_output9(inputs)
	return en_svc_browser_extensions_architect_output9(inputs)
});
export { svc_browser_extensions_architect_output9 as "svc_browser-extensions_ARCHITECT_output" }